import React from 'react'
import usePageTracking from '../hooks/usePageTracking';


export default function PageTracker() {
  usePageTracking();
  return null
}
